import { CaosConfigurationBackup } from "@/model/data/caosConfiguration/CaosConfigurationBackup";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetInstallationBackupsResData extends ApiGenericResponse {
    caosConfigurationBackups: CaosConfigurationBackup[];

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.CaosConfigurationBackups) {
            this.caosConfigurationBackups = new Array<CaosConfigurationBackup>();
            obj.CaosConfigurationBackups.forEach((backup) => {
                let b = new CaosConfigurationBackup();
                b.parse(backup);
                this.caosConfigurationBackups.push(b);
            });
        }
    }
}
